import React from "react";
import styled, { useTheme } from "styled-components";
import Text from "../Text";
import { ClipLoader } from "react-spinners";

const StyledButton = styled.button(({ theme, disabled, ...props }) => ({
  color: props.color || theme.color.white,
  fontSize: 14,
  fontWeight: 500,
  backgroundColor: disabled === true ? theme.color.gray70 : theme.color.primary,
  fontFamily: "Rubik, sans-serif",
  marginTop: 10,
  cursor: "pointer",
  height: 50,
  border: "none",
  borderRadius: 70,
  padding: `10px 24px 10px 24px`,
}));

const Button = React.forwardRef((props, ref) => {
  return (
    <StyledButton
      ref={ref}
      fullWidth={!props.notFullWidth}
      buttonStyle={props.buttonStyle}
      {...props}
    />
  );
});

const BorderButtonDiv = styled("div")(
  ({ theme, color, width, disabled, height }) => ({
    width: width ? `${width}px` : "auto",
    height: height ? `${height}px` : 36,
    display: "flex",
    padding: "10px 14px",
    flexDirection: "row",

    borderRadius: 70,
    border: `1px solid ${!disabled ? color || theme.color.primary : theme.color.gray50
      }`,
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    cursor: "pointer",
    textWrap: "nowrap",
    ":hover": {
      // light tint of the theme primary (~8% alpha) so it works for every theme
      backgroundColor: !disabled ? `${theme.color.primary}14` : theme.color.white,
    },
  })
);

export const BorderButton = ({
  onClick,
  imgSrc,
  text,
  disabled,
  color,
  isLoading,
  width,
  maxWidth,
  height,
}) => {
  const theme = useTheme();
  return (
    <BorderButtonDiv
      width={width}
      height={height}
      maxWidth={maxWidth}
      color={color}
      disabled={disabled}
      onClick={
        !disabled
          ? (e) => {
            onClick(e);
          }
          : () => null
      }
    >
      {isLoading ? (
        <ClipLoader color={color || theme.color.primary} size={20} />
      ) : (
        <>
          {imgSrc && (
            <img
              src={imgSrc}
              alt="img_src"
              style={{ width: 20, height: 20, cursor: "pointer" }}
            />
          )}
          <Text
            style={{ cursor: "pointer", lineHeight: "23px" }}
            color={
              !disabled ? color || theme.color.primary : theme.color.gray400
            }
          >
            {text}
          </Text>
        </>
      )}
    </BorderButtonDiv>
  );
};

export default Button;
